import React, { useState } from 'react';
import { useNavigate } from 'react-router';
import { Shield, ArrowLeft, AlertCircle } from 'lucide-react';
import { superAdminAuth } from '../../services/superAdminService';
import '../../styles/app7.css';

const SuperAdminLogin: React.FC = () => {
  const navigate = useNavigate();
  const [loginId, setLoginId] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);

  const submit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError(null);
    setLoading(true);
    try {
      await superAdminAuth.login(loginId, password);
      navigate('/super-admin');
    } catch (err: any) {
      setError(err?.response?.data?.detail || 'Login failed');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="sa-login-page">
      <div className="sa-login-card">
        <button type="button" className="sa-back" data-testid="BTN_superadmin_login_back" onClick={() => navigate('/login')}>
          <ArrowLeft size={16} /> Back to standard login
        </button>
        <div className="sa-login-header">
          <div className="sa-login-icon"><Shield size={28} /></div>
          <h1>Super Admin</h1>
          <p>Tenant-less administrative access. No entity selection required.</p>
        </div>
        <form onSubmit={submit} className="sa-login-form" data-testid="FORM_superadmin_login">
          {error && (
            <div className="sa-error">
              <AlertCircle size={16} /> <span>{error}</span>
            </div>
          )}
          <label>
            <span>Login ID</span>
            <input
              type="text"
              data-testid="INP_superadmin_login_username"
              value={loginId}
              onChange={(e) => setLoginId(e.target.value)}
              autoComplete="username"
              required
              autoFocus
            />
          </label>
          <label>
            <span>Password</span>
            <input
              type="password"
              data-testid="INP_superadmin_login_password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              autoComplete="current-password"
              required
            />
          </label>
          <button type="submit" className="sa-submit" data-testid="BTN_superadmin_login_submit" disabled={loading}>
            {loading ? 'Signing in…' : 'Sign in as Super Admin'}
          </button>
        </form>
      </div>
    </div>
  );
};

export default SuperAdminLogin;
